import type React from "react";
import CreateNameForm from "../common/CreateNameForm";

interface CreateCityFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { name: string }) => Promise<void>;
  error: string | null;
  initialData?: { name: string };
  isEditing?: boolean;
}

const CreateCityForm: React.FC<CreateCityFormProps> = (props) => {
  return (
    <CreateNameForm
      {...props}
      entityName="Location"
      labelTranslationKey="Location Name"
      placeholder="Kosambi, Bandung, Jawa Barat"
      addTextTranslationKey="Add Location"
      editTextTranslationKey="Edit Location"
    />
  );
};

export default CreateCityForm;
